module.exports = __webpack_public_path__ + "img/2000m.a4b1bb28.png";